import { LinkProps } from 'react-router-dom-v5-compat';
import { ButtonProps, StyledLink } from './LinkButton.styled';

export const LinkButton = ({ children, ...props }: LinkProps & ButtonProps) => (
  <StyledLink {...props}>{children}</StyledLink>
);
